module.exports = __webpack_public_path__ + "static/media/ft2-hot.ce6be8cf.png";